'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M1 2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z" /></svg>;
const IconStop = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconStop;